// app/javascript/packs/components/CoordinatesModal.jsx

import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { FormGroup, useForm, Yup } from '../components';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, Col } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

function CoordinatesModal(props) {
  const {t} = useTranslation();
  const [editable, setEditable] = useState(!props.coordinates);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)

  const {formData, setFormData, getInputProps, formProps, submitButtonProps} = useForm({
    defaultObject: props.coordinates,
    initialValues: {
      id: '',
      key: '',
      latitude: '',
      longitude: '',
      radius: ''
    },
    validationSchema: Yup.object().shape({
      key: Yup.string(),
      latitude: Yup.number().required().positive().max(90),
      longitude: Yup.number().required().min(-180).max(180),
      radius: Yup.number().allowEmptyString().positive()
    }),
    onSubmit: (data) => props.handleSubmit(data)
  })

  /*useEffect(() => {
    setFormData(props.coordinates);
    setEditable(!props.coordinates)
  }, [props.coordinates]);*/

  const handleEdit = () => setEditable(true)

  const handleCancel = () => { props.coordinates ? setEditable(false) : props.handleClose() }

  const handleAlertConfirm = () => handleDelete()
  const handleAlertCancel = () => setShowDeleteAlert(false)

  const handleDelete = () => {props.handleSubmit({...formData, delete: true})}

  return (
    <React.Fragment>
      <Modal show={props.show} onHide={props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`zone.coordinates.${props.coordinates ? 'edit' : 'add'}`)}</Modal.Title>
        </Modal.Header>
        <Form {...formProps}>
          <Modal.Body>
            <fieldset disabled={!editable}>
              <Form.Row>
                <FormGroup
                  as={Col}
                  input="text"
                  label={t("zone.coordinates.key")}
                  text={t("zone.coordinates.keyText")}
                  {...getInputProps("key")}/>
              </Form.Row>
              <Form.Row>
                <FormGroup
                  as={Col}
                  input="number"
                  label={t("latitude")}
                  {...getInputProps("latitude")}/>
                <FormGroup
                  as={Col}
                  input="number"
                  label={t("longitude")}
                  {...getInputProps("longitude")}/>
              </Form.Row>
              <FormGroup
                label={t("radius")}
                text={t("zone.coordinates.defaultRadiusText")}
                input="number"
                {...getInputProps("radius")}/>
            </fieldset>
          </Modal.Body>
          <Modal.Footer>
            {props.coordinates && !editable && <Button variant="danger" onClick={() => {setShowDeleteAlert(true)}}>
              {t("delete")}
            </Button>}
            {!editable && <Button variant="primary" onClick={handleEdit}>
              {t("edit")}
            </Button>}
            {editable && <Button variant="secondary" onClick={handleCancel}>
              {t("cancel")}
            </Button>}
            {editable && <Button variant="primary" type="submit" {...submitButtonProps}>
              {t("save")}
            </Button>}
          </Modal.Footer>
        </Form>
        {showDeleteAlert && <SweetAlert warning
                                        showCancel
                                        title={t("confirm?")}
                                        confirmBtnText={t("delete")}
                                        confirmBtnBsStyle="danger"
                                        cancelBtnText={t("cancel")}
                                        cancelBtnBsStyle="light"
                                        onConfirm={handleAlertConfirm}
                                        onCancel={handleAlertCancel}>
          {t("irreversible")}
        </SweetAlert>}
      </Modal>
    </React.Fragment>
  );
}

export default CoordinatesModal

CoordinatesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  coordinates: PropTypes.shape({
    id: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  radiusPlaceholder: PropTypes.node
}
